import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=dc094aa6&scoped=true&"
import script from "@/scripts/Password/Forget/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Password/Forget/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc094aa6",
  null
  
)

export default component.exports